import React, { Component } from 'react';

import './BlendArea.css';
class BrickRow extends Component {

  shouldComponentUpdate(nextProps, nextState) {
  
    if (this.props.bricks !== nextProps.bricks || this.props.accentBrickId !== nextProps.accentBrickId
      || this.props.accentEveryRow !== nextProps.accentEveryRow) {
      return true;     
    }
    return false;
  }

  render() {
    let r = this.props.row;
    return (
      
      <div className="brick-row">
        {[...Array(this.props.bricksPerRow)].map((_, b) => {
          let brickIndex = r * this.props.bricksPerRow + b;
          let brickTransform = (Math.floor(Math.random() * 4) + 1);
          let brickImageUrl = this.props.brickArray[brickIndex];

          if (r > 0 && this.props.accentBrickId !== "" && (r+1) % this.props.accentEveryRow === 0)
          {
            let accentBrick = this.props.bricks.filter((brick) => brick.id === this.props.accentBrickId)[0];
            //randomly select 1 of 10 images         
            brickImageUrl = accentBrick.images + '/' + (Math.floor(Math.random() * 10) + 1) + '.png';
          }

          return (
            <div key={brickIndex} className={'pos' + brickTransform} style={{ content: 'url(' + brickImageUrl + ')',backgroundImage: 'url(' + brickImageUrl+ ')' }}></div>
          )
        }, this)}
      </div>
    );
  }

}

export default BrickRow;
